@import '../../themes/capsule.globals';

:host {
  --card-padding-top: 24px;
  --card-padding-end: 24px;
  --card-padding-bottom: 24px;
  --card-padding-start: 24px;
  --card-border-width: 1px;
  --card-border-color: var(--cpsl-color-card-border);
  --card-border-radius-tl: var(--cpsl-border-radius-card);
  --card-border-radius-tr: var(--cpsl-border-radius-card);
  --card-border-radius-bl: var(--cpsl-border-radius-card);
  --card-border-radius-br: var(--cpsl-border-radius-card);
  --card-background-color: var(--cpsl-color-card-surface);

  display: block;
}

.card {
  @include padding(var(--card-padding-top), var(--card-padding-end), var(--card-padding-bottom), var(--card-padding-start));

  display: block;
  box-sizing: border-box;
  overflow: hidden;

  border: var(--card-border-width) solid var(--card-border-color);
  border-radius: var(--card-border-radius-tl) var(--card-border-radius-tr) var(--card-border-radius-br) var(--card-border-radius-bl);
  background: var(--card-background-color);
}
